// extracted by css-extract-rspack-plugin
export default {"root":"dcsL49qDmwMz5NU_","sidebar":"SA0vWq7COjkTQqaR","content":"jDUpixqmBe8pb_aZ"};